<template lang="html">
  <div class="appt-slide">

    <div class="appt-slide-body">
    
      <h3>Let's Get You Scheduled</h3>
      <p><em>Team members: go to open dental and look up next available appointment slot</em></p>
      <p><strong>"We have these times in the next few days"</strong></p>

      <hr class="hr-dark-color" />

      <h3>Would you like us to call you if an earlier appointment opens up?</h3>
      <p><em>Team members: select a scheduled appointment and click the button to add the patient to the ASAP list.</em></p>
      <p><strong>Upcoming Scheduled Appointments</strong> <button class="btn btn-link btn-link-inline" @click="loadAppts">refresh</button></p>
      <p class="loading-appts" v-if="loadingAppts"><i class="far fa-fw fa-pulse fa-spinner"></i></p>
      <p v-if="(!schedAppointments || !schedAppointments.length) && !loadingAppts">No scheduled appointments found. Create an appointment for the patient in Open Dental, then click refresh.</p>
      <div v-if="schedAppointments && schedAppointments.length && !setAsapPrioritySuccess">
        <div v-for="appt in schedAppointments" :key="appt.AptNum" class="form-check">
          <input type="radio" :id="appt.AptNum" :name="appt.AptNum" v-model="selectedAptNum" :value="appt.AptNum" class="form-check-input">
          <label :for="appt.AptNum" class="form-check-label">
            {{ appt.AptDateTime | prettyDateTimeShort }} 
            <span v-if="appt.provAbbr">with {{ appt.provAbbr }} </span>
            ({{ appt.lengthInMinutes }} min) 
            <span v-if="appt.Priority == 1 || appt.Priority == 'ASAP'">Status: <strong>ASAP</strong></span>
          </label>
        </div>
        <button v-if="!loadingAppts" class="btn btn-link" @click="setAsapPriority">add to ASAP list</button>
      </div>
      <p v-if="setAsapPrioritySuccess" class="text-success"><i class="far fa-check color-green"></i> Patient added to ASAP list successfully!</p>

      <hr class="hr-dark-color" />

      <h3 class="snug">Did the patient schedule?</h3>
      <p>Did you schedule the patient in Open Dental?</p>
      <div class="form-check">
        <input type="radio" id="scheduled-yes" name="ptDidSchedule" v-model="ptDidSchedule" :value="true" class="form-check-input">
        <label for="scheduled-yes" class="form-check-label">Yes</label>
      </div>
      <div class="form-check">
        <input type="radio" id="scheduled-no" name="ptDidSchedule" v-model="ptDidSchedule" :value="false" class="form-check-input">
        <label for="scheduled-no" class="form-check-label">No</label>
      </div>

      <div v-if="ptDidSchedule">
        <h3>How long until the next appointment?</h3>
        <select v-model="intervalUntilNextAppt" class="form-control">
          <option disabled :value="null">select one</option>
          <option v-for="interval in validIntervals" :key="interval.code" :value="interval.code">{{ interval.name }}</option>
        </select>
      </div>
      
      <div v-if="!ptDidSchedule">
        <h3>Why not?</h3>
        <select v-model="scheduleDeclineReason" class="form-control">
          <option disabled :value="null">select a reason</option>
          <option v-for="reason in validReasons" :key="reason.code" :value="reason.code">{{ reason.name }}</option>
        </select>
      </div>

      <div v-if="threeHourSchedAptFound">
        <hr class="hr-dark-color" />
        <h3>We collect 30% of the copayment up front to reserve that time just for you</h3>

        <div class="form-check">
          <input type="checkbox" id="deposit-paid" name="depositPaid" v-model="depositPaid" :value="depositPaid" class="form-check-input">
          <label for="deposit-paid" class="form-check-label">30% deposit paid for next appointment</label>
        </div>
      </div>

      <hr class="hr-dark-color" />

      <p class="saving" v-if="saving"><i class="far fa-fw fa-pulse fa-spinner"></i> saving, please wait...</p>
      <p class="text-center" v-if="!saving"><button @click.prevent="updateEncounter" class="btn btn-green btn-lg">Save &amp; Close<i class="fas fa-angle-right fa-fw"></i></button></p>
    </div> <!-- /.appt-slide-body -->

  </div> <!-- /.appt-slide -->
</template>

<script>
import Vue from 'vue'
import {mapGetters} from 'vuex'

export default {
  components: {
    
  },
  data() {
    return {
      saving: false,
      depositPaid: false,
      loadingAppts: false,
      schedAppointments: null,
      selectedAptNum: null,
      setAsapPrioritySuccess: false,
      ptDidSchedule: false,
      intervalUntilNextAppt: null,
      scheduleDeclineReason: null,
      validIntervals: [
        {name: '1 Day', code: '1-day'},
        {name: '1 Week', code:  '1-week'},
        {name: '2 Weeks', code: '2-week'},
        {name: '1 Month', code: '1-month'},
        {name: 'More than 1 month', code: 'more'},
      ],
      validReasons: [
        {name: 'Financial hesitation', code: 'financial'},
        {name: 'Timing / life constraint', code: 'timing'},
        {name: 'Needs more understanding', code: 'needs_understanding'},
        {name: 'Emotional resistance', code: 'emotional'},
        {name: 'Perceived low urgency', code: 'low_urgency'},
        {name: 'Seeking second opinion / external input', code: 'second_opinion'},
        {name: 'Clinical deferral', code: 'clinical_deferral'},
        {name: 'Submitted pre-authorization', code: 'submitted_pre_auth'},
      ],
    };
  },
  computed: {
    ...mapGetters(['user', 'user_props', 'custom_claims', 'appointment', 'encounter','treatment_plan', 'pat_num', 'pat_name']),
    threeHourSchedAptFound() {
      if(this.schedAppointments && this.schedAppointments.length) {
        return this.schedAppointments.some(appt => appt.lengthInMinutes >= 180);
      }
      return false;
    },
  },
  watch: {
    pat_num(newVal) {
      if(newVal) {
        this.loadAppts();
      }
    },
    encounter(newVal) {
      this.prefillFromEncounterData();
    },
  },
  methods: {
    prefillFromEncounterData() {
      const data = this.encounter;
      if(!data || typeof data !== 'object') {
        return;
      }

      if(Object.prototype.hasOwnProperty.call(data, 'deposit_paid') && data.deposit_paid !== null) {
        this.depositPaid = data.deposit_paid;
      }

      if(Object.prototype.hasOwnProperty.call(data, 'pt_did_schedule') && data.pt_did_schedule !== null) {
        this.ptDidSchedule = data.pt_did_schedule;
      }

      if(Object.prototype.hasOwnProperty.call(data, 'interval_until_next_appt')) {
        this.intervalUntilNextAppt = data.interval_until_next_appt;
      }

      if(Object.prototype.hasOwnProperty.call(data, 'schedule_decline_reason')) {
        this.scheduleDeclineReason = data.schedule_decline_reason;
      }
    },
    // convert this function to async style and add error handling
    async setAsapPriority() {
      // validate data requirements then call cloud function to set priority
      if(!this.custom_claims || !this.custom_claims.customerId || !this.custom_claims.authorized_location || !this.user || !this.user.uid || !this.selectedAptNum) {
        console.error('Missing required data to set appointment priority');
        return false;
      }
      this.loadingAppts = true;
        
      try {
        const setApptPriority = Vue.functions.httpsCallable('setAppointmentAsapPriority');
        await setApptPriority({
          // include uid, customerId, locationId
          uid: this.user.uid,
          customerId: this.custom_claims.customerId,
          locationId: this.custom_claims.authorized_location,
          aptNum: this.selectedAptNum,
        });
        console.log('appointment priority updated successfully');
        this.setAsapPrioritySuccess = true;
      } catch (err) {
        console.error('Failed to set appointment as ASAP priority:', err);
      } finally {
        this.loadingAppts = false;
      }
    },
    // write new function to load scheduled appointments for the patient from open dental using cloud function, then store the results in schedAppointments data property
    async loadAppts() {
      if(!this.custom_claims || !this.custom_claims.customerId || !this.custom_claims.authorized_location || !this.user || !this.user.uid || !this.pat_num) {
        console.error('Missing required data to load appointments');
        return false;
      }
      try {
        this.loadingAppts = true;
        this.setAsapPrioritySuccess = false;
        const loadApptsByPatNum = Vue.functions.httpsCallable('loadAppointmentsByPatNum');
        const appts = await loadApptsByPatNum({
          // include uid, customerId, locationId
          uid: this.user.uid,
          customerId: this.custom_claims.customerId,
          locationId: this.custom_claims.authorized_location,
          patNum: this.pat_num,
        });
        this.schedAppointments = appts.data || [];
      } catch (err) {
        console.error('Failed to load appointments:', err);
      } finally {
        this.loadingAppts = false;
      }
    },
    async updateEncounter() {
      // validate data
      if(!this.custom_claims || !this.custom_claims.customerId || !this.custom_claims.authorized_location || !this.user || !this.user.uid || !this.encounter || !this.encounter.encounter_id) {
        console.error('Missing required data');
        return false;
      }
      let encounterObject = {
        ...this.encounter,
        pt_did_schedule: this.ptDidSchedule,
        interval_until_next_appt: this.intervalUntilNextAppt,
        schedule_decline_reason: this.scheduleDeclineReason,
        encounter_setup_status: 'aptComplete',
        deposit_paid: this.depositPaid,
        deposit_required: this.threeHourSchedAptFound,
      };
      // update in firestore
      let encounterRef = Vue.firestore.doc(`/customers/${this.custom_claims.customerId}/locations/${this.custom_claims.authorized_location}/encounters/${encounterObject.encounter_id}`);
      try {
        this.saving = true;
        await encounterRef.update(encounterObject);
        // console.log('encounter updated successfully');
        // then close encounter, clear data, route to appointments page
        this.$store.dispatch('clearEncounter');
        this.$store.dispatch('clearAppointment');
        this.$store.dispatch('clearPatNum');
        this.$store.dispatch('clearPatName');
        this.$store.dispatch('clearTreatmentPlan');
        this.$router.push({ name: 'appointmentSelect' });
      } catch (err) {
        console.error('Failed to update encounter during save progress:', err);
      }
      this.saving = false;
    },
  },
  mounted() {
    this.prefillFromEncounterData();
    if(this.pat_num) {
      this.loadAppts();
    }
  },
}
</script>

<style lang="less" scoped>
@import "../assets/less/variables.less";

h1 {
  margin-bottom: 20px;
}
.tp-title {
  text-align: center;
  padding: 20px;
  border-bottom: 1px solid @dark-color;
  margin-bottom: 30px;

  h5,p {
    margin: 0;
  }
}
h5 {
  margin-bottom: 30px;
}
.appt-slide {
  padding: 0;
}
.appt-slide-body {
  padding: 0 30px 30px;
}
hr {
  margin: 30px 0;
}
h1 {
  margin: 20px 0;
}
h3 {
  margin: 15px 0;
  font-weight: bold;
}
.btn-link-inline {
  vertical-align: baseline;
  line-height: 1.5em;
}
</style>
